import { oneLbInKg } from '../constants/constant.js';
export const calculator = (weight, prefer, btn) => {
  if (!btn) weight = Math.round(Number(weight) / oneLbInKg);

  let result = {};
  const getDose = () => {
    if (weight >= 20 && weight < 30) {
      return {
        leger: 15,
        moyen: 20,
        intense: 36,
      };
    } else if (weight >= 30 && weight < 40) {
      return {
        leger: 22,
        moyen: 30,
        intense: 54,
      };
    } else if (weight >= 40 && weight < 50) {
      return {
        leger: 30,
        moyen: 40,
        intense: 72,
      };
    } else if (weight >= 50 && weight < 60) {
      return {
        leger: 38,
        moyen: 50,
        intense: 90,
      };
    } else if (weight >= 60 && weight < 70) {
      return {
        leger: 44,
        moyen: 60,
        intense: 108,
      };
    } else if (weight >= 70 && weight < 80) {
      return {
        leger: 52,
        moyen: 70,
        intense: 126,
      };
    } else if (weight >= 80 && weight < 90) {
      return {
        leger: 60,
        moyen: 80,
        intense: 144,
      };
    } else if (weight >= 90 && weight < 100) {
      return {
        leger: 66,
        moyen: 90,
        intense: 162,
      };
    } else if (weight >= 100) {
      return {
        leger: 75,
        moyen: 100,
        intense: 180,
      };
    } else {
      return {
        leger: 0,
        moyen: 0,
        intense: 0,
      };
    }
  };

  const dose = getDose();

  if (prefer === 'leger') {
    result = {
      cbd5: Math.round(dose.leger / 2.5),
      cbd10: Math.round(Math.round(dose.leger / 2.5) / 2),
      cbd15: Math.round(Math.round(dose.leger / 2.5) / 3),
      cbd20: Math.round(Math.round(dose.leger / 2.5) / 2 / 2),
      cbd30: Math.round(Math.round(dose.leger / 2.5) / 2 / 3),
    };
  } else if (prefer === 'moyen') {
    result = {
      cbd5: Math.round(dose.moyen / 2.5),
      cbd10: Math.round(Math.round(dose.moyen / 2.5) / 2),
      cbd15: Math.round(Math.round(dose.moyen / 2.5) / 3),
      cbd20: Math.round(Math.round(dose.moyen / 2.5) / 2 / 2),
      cbd30: Math.round(Math.round(dose.moyen / 2.5) / 2 / 3),
    };
  } else if (prefer === 'intense') {
    result = {
      cbd5: Math.round(dose.intense / 2.5),
      cbd10: Math.round(Math.round(dose.intense / 2.5) / 2),
      cbd15: Math.round(Math.round(dose.intense / 2.5) / 3),
      cbd20: Math.round(Math.round(dose.intense / 2.5) / 2 / 2),
      cbd30: Math.round(Math.round(dose.intense / 2.5) / 2 / 3),
    };
  } else {
    result = {
      cbd5: 0,
      cbd10: 0,
      cbd15: 0,
      cbd20: 0,
      cbd30: 0,
    };
  }

  return result;
};
